module.exports = __webpack_public_path__ + "img/zyyhj.a4ad8c6.png";